/**
 * check if its rendering inside a webview, used in iclinic mobile apps
 */
export const isReactWebView = () =>
  typeof window !== 'undefined' && window.ReactNativeWebView;
